var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","x-large":_vm.xLarge,"large":_vm.large,"rounded":"","to":"/app/mona-ai"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-creation ")]),_vm._v(" Ask Mona ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }